import { FormEvent, useState } from 'react';
import { useTranslation } from '@/context/TranslationContext';
import { useNewsletterSubscription } from '@/lib/queries/newsletter';
import toast from 'react-hot-toast';
import styles from './Newsletter.module.scss';

export function Newsletter() {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const newsletterMutation = useNewsletterSubscription();

    const validateEmail = (email: string) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault();
        setError('');

        if (!email) {
            setError('required');
            return;
        }

        if (!validateEmail(email)) {
            setError('email');
            return;
        }

        newsletterMutation.mutate(email, {
            onSuccess: (result) => {
                if (result.success) {
                    toast.success(t('NEWSLETTER.SUCCESS'));
                    setEmail('');
                } else {
                    toast.error(t('NEWSLETTER.ERROR'));
                }
            },
            onError: (error) => {
                console.error('Newsletter subscription error:', error);
                toast.error(t('NEWSLETTER.ERROR'));
            }
        });
    };

    return (
        <section className={styles.newsletterSection}>
            <div className={styles.newsletterContainer} data-aos="fade-up">
                <div className={styles.newsletterContent}>
                    <div className={styles.newsletterIcon}>
                        <i className='bx bx-envelope'></i>
                    </div>
                    <h2>{t('NEWSLETTER.TITLE')}</h2>
                    <p>{t('NEWSLETTER.DESCRIPTION')}</p>
                </div>

                <form onSubmit={onSubmit} className={styles.newsletterForm}>
                    <div className={styles.formGroup}>
                        <div className={styles.inputWrapper}>
                            <i className='bx bx-envelope'></i>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder={t('NEWSLETTER.FORM.EMAIL_PLACEHOLDER')}
                                className={error ? styles.error : ''}
                            />
                        </div>
                        {error && (
                            <span className={styles.errorMessage}>
                                {error === 'required' ? t('NEWSLETTER.FORM.REQUIRED') : t('NEWSLETTER.FORM.INVALID')}
                            </span>
                        )}
                    </div>

                    <button type="submit" disabled={newsletterMutation.isPending} className={styles.submitButton}>
                        {newsletterMutation.isPending ? (
                            <>
                                <span className={styles.spinner}></span>
                                {t('NEWSLETTER.FORM.SUBMITTING')}
                            </>
                        ) : (
                            <>
                                <i className='bx bx-send'></i>
                                {t('NEWSLETTER.FORM.SUBMIT')}
                            </>
                        )}
                    </button>
                </form>
            </div>
        </section>
    );
}
